module.exports = __webpack_public_path__ + "static/media/gt-america-standard-regular-italic.1519315c.woff";